import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ProductionPage from "@/pages/ProductionPage";
import InventoryPage from "@/pages/InventoryPage";
import PalletDetailPage from "@/pages/PalletDetailPage";
import PalletScanRedirect from "@/pages/PalletScanRedirect";
import ShipmentsPage from "@/pages/ShipmentsPage";
import ReportsPage from "@/pages/ReportsPage";
import ProductsPage from "@/pages/ProductsPage";
import CustomersPage from "@/pages/CustomersPage";
import UsersPage from "@/pages/UsersPage";

function Protected({ children, roles, bare }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 tracking-widest text-xs uppercase">
        Loading…
      </div>
    );
  }
  if (user === false) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (roles && !roles.includes(user.role) && user.role !== "admin")
    return <Navigate to="/" replace />;
  return bare ? children : <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/p/:code" element={<Protected bare><PalletScanRedirect /></Protected>} />
      <Route path="/" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/production" element={<Protected roles={["admin", "operator"]}><ProductionPage /></Protected>} />
      <Route path="/inventory" element={<Protected><InventoryPage /></Protected>} />
      <Route path="/pallets/:id" element={<Protected><PalletDetailPage /></Protected>} />
      <Route path="/shipments" element={<Protected roles={["admin", "shipping", "viewer"]}><ShipmentsPage /></Protected>} />
      <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
      <Route path="/catalog/products" element={<Protected><ProductsPage /></Protected>} />
      <Route path="/catalog/customers" element={<Protected><CustomersPage /></Protected>} />
      <Route path="/users" element={<Protected roles={["admin"]}><UsersPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
